module.exports = __webpack_public_path__ + "static/media/object.92a50780.gif";